import styled from 'styled-components';
import { AUTH_TOKEN_BG, BASIC_PLAN_BACKGROUND, CRYPTO_PRO_PLAN_BACKGROUND, FIAT_MASTER_PLAN_BACKGROUND } from '../../config/media';

const Wrapper = styled.div`
	position: relative;
	.content-body {
		color: #ffffff;
	}
	.c-plan {
		margin-top:12px;
	}
	.main-panel {
		width: 100%;
		height: 368px;
		background-color: #f6f6f6;
		background-image: url(${AUTH_TOKEN_BG});
		background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom;
		padding: 40px 75px;
		position: relative;
		box-sizing: border-box;
		color: #fff;
		.ant-btn {
			position: absolute;
			top: 40px;
			right: 110px;
			font-size: 22px;
			height: auto;
		}
		h2 {
			font-size: 35px;
			font-weight: bold;
			margin-bottom: 14px;
            color: #fff;
            position: relative;
            top: 50%;
		}
		p {
			.advatages {
				text-indent: 12px;
				display: block;
			}
			.click {
				cursor: pointer;
				color: #5985ff;
				text-decoration: underline;
			}
		}
    }
    .content-panel {
        padding: 32px 71px;
		.ant-calendar-range-picker-separator {
			color: #ffffff
    }
		.ant-calendar-picker-input {
			background-color : #212121;
			color: #fff
			/* border:1px solid #fff !important */
		}
    }
	.msg-container {
		padding: 0 71px;
	}
	.steps-content-wrapper {
		.discount-wrapper {
			margin-bottom: 5%;
			.ant-tooltip-inner-content {
				font-size: 12px !important;
			}
			.custom-info-circle {
				color: white;
    			margin: 0.7% 1%;
			}
			.dicount-header {
				font-weight: bold;
				.dicount-sub-header {
					font-weight: 100;
				}
			}
			.discount-field-wrapper {
				.ant-input {
					width: 50%;
					border-radius: 0px !important;
				}
				.incorrect-disabled-state, .incorrect-disabled-state:hover {
					border: 1px solid #FF0000 !important;
				}
				.disabled-state {
					opacity: 0.3;
				}
				.apply-btn {
					margin-left: 3%;
				} 
				.discount-applied-label {
					color: #0F9400;
					margin: 1% 3%;
					.discount-checked-icon {
						margin-top: 1%;
					}
					.success-discount-label {
						margin-left: 5px;
					}
				}
			}
			}
		}
		.incorrect-wrapper {
			margin-bottom: 2% !important;
		}
		.error-filed-wrapper {
			color: #FF0000;
			padding: 0.6%;
	}
	@media (max-width: 1200px) {
        z-index: 0;
        .content-panel,
		.main-panel {
			padding: 24px;
			padding-left: 28px;
			h2 {
				font-size: 24px;
			}
		}
		.main-panel {
			font-size: 12px;
			.ant-btn {
				top: 33px;
				right: 8px;
			}
		}
    }
    .link {
        cursor: pointer;
    }
    .payment-icon {
		margin: 1rem auto;
		width: 2.5rem;
	}
	.cloud-icon {
		margin: 0.5rem auto;
		width: 1rem;
	}
	.cloud-icon-normal {
		width: 3.5rem;
		height: 3.5rem;
		padding-left: 1rem;
	}
	.d-flex {
		display: flex;
	}
	.align-center {
		align-items: center;
	}
	.payment-container {
		margin-top: 1.5rem;

		.details {
			padding: 1.5rem 1rem;
			margin: 0.5rem 0;
			text-align: center;
			width: 38%;
			border-right: 1px solid #A9A9A9;
		}
		.data-content {
			flex: 1;
			margin: auto 0;
			.ant-breadcrumb .breadcrumb-item-active {
			border-top: 5px solid #ffffff;
			color: #ffffff;
			cursor: pointer;
			}
		}
		.steps-wrapper {
			padding: 0rem 2rem;
		}
		.steps-content-wrapper {
			padding: 0rem 2rem;
			.input-field-wrapper {
				min-height: 8rem;
				width: 200px;
				margin: 10px 0 ;
			}
			.flag-icon {
				height: 16px;
    			width: 24px;
			    margin: 5px;
			}
			.payment-details-wrapper {
				padding: 1rem 1rem;
    			border: 1px solid;
			}
			.no-border {
				border-top: none;
			}
			.xht-disabled {
				cursor: not-allowed;
				pointer-events: none;
				opacity: 0.4;
			}
		}
		.amount {
			font-size: 26px;
			color: #0000FF;
    		cursor: unset;
		}
		.danger {
			color: #F83E18;
		}
		.fire-icon {
			width: 0.75rem;
		}
		.amount-desc {
			font-size: 12px;
		}
		.currency-content {
			padding-top: 0.25rem;
		}
		.crypto-error {
			color: #FF0000;
			font-size: 12px;
		}
		.crypto-payment-divider {
			border-bottom: 1px solid #707070;
			margin: 1rem;
			width: 5rem;
		}
		.qr-code-wrapper {
			margin-left: 6rem;
		}
		.cloud-plan-wrapper {
			background-color: #29292C;
			border-top: 2px dotted #C4C4C4;
			position: relative;
			top: 0.5rem;
			.cloud-content {
    			padding: 2rem;
				.plans-title-wrapper {
					display: flex;
					justify-content: space-between;
				}
				.display-discount {
					color: #0F9400;
					display: flex;
					justify-content: space-between;
    				width: 19%;
					padding-top: 3%;
					.checked-discount-icon {
						width: 10%;
						margin-bottom: 5%;
					}
					.discount-percentage-label {
						color: #0F9400;
					}
				}
			}
			.cloud-box-container {
				padding:1rem;
    			justify-content: space-around;
				background-color: #29292C;
				border: 1px solid #42454D;
				.sub-title {
					white-space: nowrap;
					font-size: 16px;
					font-weight: bold;
					margin-right: 5px;
				}
				.cloud-icon,
				.exchange-icon {
    				width: 40px;
    				margin-right: 15px;
				}
				.content-align {
					justify-content: center;
					align-items: center;
					padding: 0 0.5rem;
				}
				.seperator {
					border-left: 1px solid #42454D;
					border-right: 1px solid #42454D;
				}
			}
		}
		.enterprise-form-wrapper {
			.enterprise-form {
				margin: 2rem;
			}
		}
	}
	.ant-breadcrumb {
    	font-size: 20px;
		font-weight: bold;
		margin: 1rem 0;
		
		a {
		   color: #fff ;
			  text-decoration: none;
		  }
		  a:hover {
			  color: #ffffff;
		  }
		  }
		.ant-breadcrumb-link {
			color: #A8A8B1;
		.breadcrumb-item {
			padding-top: 0.8rem;
			color: #A8A8B1;
			cursor: pointer;
		}
		.breadcrumb-item-active {
			border-top: 5px solid #A8A8B1;
			color: #A8A8B1;
			cursor: pointer;
		}
	}
	.f-1 {
		flex: 1;
	}
	.my-1 {
		margin: 1rem 0;
	}
	.my-mini {
		margin: 0.25rem 0;
		.ant-select {
			width: 300px;
		}
	}
	.timer-divider {
		margin: 0px 0.5rem;
	}
	.crypto-required-amount {
		color: #0000FF;
		font-size: 27px;
	}
	.bank-icon {
		width: 2.5rem;
	}
	.bold {
		font-weight: bold;
		color: #ffffff;
	}
	.mail-title {
		font-size: 30px;
	}
	.large-text {
		font-size: 18px;
	}
	.bodyContent {
		color: #ffffff;
		font-size: 11px;
	}
	.bodyContentSmall {
		color: #ffffff;
		font-size: 12px;
	}
	.warning-text {
		color: red;
		font-size: 14px;
	}
	.warning-icon {
		margin: 5px;
	}
	.price-offer {
		border-bottom: 1px solid #A9A9A9;
		margin-bottom: 0.5rem;
		padding-bottom: 8px;
		width: 150px;
	}
	.offer {
		color: #288500;
	}
	.amount-text {
		color: #A9A9A9;
	}
	.button-container {
		padding: 0.5rem 1rem;
		.ant-btn {
			height: 45px;
		}
	}
	.btn-divider {
		margin: 0.25rem;
	}
	.separator {
		background-color: #A1A1A1;
		margin: 0 1rem;
		position: relative;
		width: 1px;
		.line {
			background-color: #000;
			color: #ffffff;
			position: absolute;
			font-weight: bold;
			top: 45%;
			left: -6px;
		}
	}
	.text-center {
		text-align: center;
	}
	.filter {
		margin-bottom: 10px;
		.label {
			text-align: end;
			font-size: 12px;
		}
	}
	.divider {
		/* border-top: 3px solid #A8A8B1;
		border-bottom: 3px solid #A8A8B1; */
    	padding: 10px;
		/* color: #A8A8B1; */
		background-color: #212121;
		height: 15rem;
		padding: 2rem 3rem;
	}
	.pading-left {
		padding-left: 10px;
		padding-top: 5px;
	}
	.content-panel {
		.ant-tabs {
			border-top: 3px solid #A8A8B1;
    		padding-top: 20px;
		}
		.wrapper-container {
			position: relative;
			height: 27rem;
			.card-container {
				position: absolute;
				top: 30%;
				padding-left: 3rem;
			}
			h3 {
				font-size: 25px;
				font-weight: bold;
			}
			.anchor {
				color: #5985ff;
				text-decoration: underline;
				cursor: pointer;
			}
			.box-container {
				margin: 2rem 0rem;
				border: 1px solid #A8A8B1;
				border-radius: 7px;
				width: 400px;
				color: #A8A8B1;
				.card-design {
					height: 15px;
					border-radius:5px 5px 0px 0px;
				}
				.basic-color {
					background: #C4C8AC;
				}
				.crypto-color{
					background: #5CB5F9;
				}
				.fiat-color{
					background: #00FFFF;
				}
				.cloud-icon {
					width: 3.5rem;
					height: 3.5rem;
				}
				.diy-icon-circle {
					align-items: center;
					background-color: #212121;
					border: 1px solid #EFEFEF;
					border-radius: 50%;
					display: flex;
					height: 3.5rem;
					justify-content: center;
					width: 3.5rem;
	
					.cloud-icon {
						width: 3.5rem;
						height: 2rem;
					}
				}
				.plan-icon {
					margin-left: 6px;
					width: 1.2rem;
				}
				.card-wrapper {
					display: flex;
					justify-content: space-between;
					padding: 2rem 1rem;
				}
				.DIY-boost-bg {
					background-color: #29292C;
					border-radius: 7px;
				}
				.initial-card,
				.basic-plan,
				.crypto_pro-plan,
				.fiat_master-plan {
					position: relative;
					z-index: 1;
				}
				.initial-card {
					height: 10rem;
				}
				.initial-card::before {
					content: "";
					position: absolute;
					top: 0px;
					right: 0px;
					bottom: 0px;
					left: 0px;
					z-index: -1;
				}
				.basic-plan::before {
					content: "";
					background-position: right;
					background-size: contain;
					background-image: url(${BASIC_PLAN_BACKGROUND});
					background-repeat: no-repeat;
					background-color: #212121;
					/* opacity: 0.6; */
					position: absolute;
					top: 0px;
					right: 0px;
					bottom: 0px;
					left: 0px;
					z-index: -1;
				}
				.crypto_pro-plan::before {
					content: "";
					background-position: center;
					background-size: cover;
					background-image: url(${CRYPTO_PRO_PLAN_BACKGROUND});
					background-repeat: no-repeat;
					background-color: #29292C;
					/* opacity: 0.6; */
					position: absolute;
					top: 0px;
					right: 0px;
					bottom: 0px;
					left: 0px;
					z-index: -1;
				}
				.fiat_master-plan::before {
					content: "";
					background-image: url(${FIAT_MASTER_PLAN_BACKGROUND});
					background-position: right;
					background-size: contain;
					background-repeat: no-repeat;
					background-color: #29292C;
					/* opacity: 0.6; */
					position: absolute;
					top: 0px;
					right: 0px;
					bottom: 0px;
					left: 0px;
					z-index: -1;
				}
				.content-align {
					margin-left: 5px;
					flex: 1;
	
					.card-title {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 5px;
					}
					.cloud-label {
						color: #ffffff;
						font-size: 16px;
						font-weight: bold;
					}
					.list-text {
						font-size: 12px;
						color: #000000;
					}
				}
				/* .card-divider {
					border-top: 1px solid #E6E6E6;
				} */
				.card-sub-content {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					padding: 10px;
					.ant-btn {
						border-radius: 15px;
						font-size: 12px;
						min-width: 4rem;
						line-height: 1;
						height: 26px;
						padding: 0px 6px;
					}
					.paid-btn, .paid-btn:hover {
						background-color: #288500 !important;
						border-color: #288500 !important;
						.anticon {
							font-size: 18px;
							margin-right: 4px;
						}
					}
				}
			}
			.plan-wrapper {
				cursor: pointer;
				font-size: 12px;
				color: #808083;
			}
			.download-text-wrapper {
				display: flex;
			}
		}
	}
	.confirmation-wrapper {
		padding: 3rem;
		width: 100%;
		padding-bottom: 1rem;
		.send-mail-icon {
			margin-right: 1rem;
			width: 4rem;
		}
		.main-info {
			margin: 1rem 0 2rem 0;
		}
		.kyc-btn-wrapper {
    		padding: 3rem 0 1rem 0;
			.ant-btn {
				height: 45px;
			}
		}
		.verify-icon-wrapper {
			position: relative;
    		display: inline;
			.kyc-icon {
				width: 4rem;
    			margin-bottom: 1rem;
			}
			.verify-icon {
				width: 20px;
				position: absolute;
				left: 53px;
				bottom: 31px;
			}
		}
	}
	.small-text {
		font-size: 12px;
	}
	.billing-package-text {
		text-transform: capitalize;
	}
	.ant-tabs {
		color: #fff;
		.ant-tabs-nav .ant-tabs-tab-active {
			color: #3A4FFF;
	}

	@media (max-width: 960px) {
		.content-panel {
			padding: 10px;
			padding-left: 10px;
			.box-container {
				width: 100%;
				max-width: 20rem;
				.card-wrapper {
					padding: 1rem;
				}
				.cloud-icon {
					width: 2rem;
					height: 2rem;
					margin: 0;
				}
			}
		}
		.table-wrapper {
			overflow-x: scroll;
		}
		.cloud-box-container {
			flex-direction: column;
			.cloud-icon {
				margin: 15px;
			}
		}
		.steps-wrapper {
			.ant-breadcrumb {
				font-size: 16px;
			}
		}
		.large-text {
			font-size: 15px;
		}
		.mail-title {
			font-size: 18px;
		}
		.mobile-qr-wrapper {
			flex-direction: column;
		}
		.payment-container {
			.qr-code-wrapper {
				margin: 0rem;
			}
			.ant-form label {
				font-size: 13px;
			}
		}
		.steps-wrapper {
			.ant-breadcrumb {
				font-size: 13px;
			}
			.ant-breadcrumb-separator {
				margin: 0 4px;
			}
			.anticon {
				font-size: 12px;
			}
		}
		.crypto-required-amount {
			font-size: 20px;
		}
		.payment-container {
			.cloud-plan-wrapper {
				.cloud-content {
					padding: 1rem;
				}
				.cloud-box-container {
					padding: 0.5rem;
				}
			} 
		}
		.confirmation-wrapper {
			padding: 1rem;
		}
	}
	}
	@media (max-width: 540px) {
		.content-panel {
			.wrapper-container {
				.box-container {
					width: auto;
				}
				.card-container {
					padding-top: 3rem;
				}
			}
		}
		.cloud-plan-wrapper {
			flex-direction: column;
			.cloud-content {
				.plans-title-wrapper {
					text-align: center;
					flex-direction: column;
				}
				.display-discount {
					justify-content: center !important;
					width: 100% !important;
					padding: unset !important;
				}
			}
			.cloud-box-container {
				flex-direction: column;
				justify-content: center;
				.content-align {
					flex-direction: column;
					.cloud-icon {
						margin:0px
					}
					.sub-title {
						text-align:center;
					}
				}
			}
		}
		.payment-container {
			.qr-code-wrapper {
				margin-left: 0;
			}
			.steps-content-wrapper {
				.discount-wrapper {
					.custom-info-circle {
    					margin: 2% 1%;
					}
					.dicount-header {
						font-size: 13px;
					}
					.discount-field-wrapper {
						.apply-btn {
							width: 50%;
						} 
					.discount-applied-label {
						font-size: 10px;
					}
				}
			}
			}
			.steps-content-wrapper .payment-details-wrapper {
				flex-direction: column;
			}
		}
		.ant-breadcrumb {
    		font-size: 15px;
		}
	}
	@media (max-width: 435px) {
		.content-panel {
			.wrapper-container {
				.flex-content, .card-title {
					display: flex;
					flex-direction:column;
				}
				& div {
					.image-container {
						display: flex;
						justify-content: center;
						.cloud-icon-normal {
							width: 4.5rem;
						}
					}
				}
				height: 38rem;
				.divider {
					height: 20rem;
				}
				.card-container {
					top: 40%;
				}
				.box-container {
					width: auto;
					.card-wrapper {
						.img-center {
							display: flex;
							justify-content:center;
						}
						.content-align {
							text-align:center;
						}
					}
					.paid-btn {
						.anticon {
							font-size: 12px !important;
						}
					}
				}
			}
			.filter {
				.flex-container {
					flex-direction:column;
					.ant-select {
						width: 100% !important;
						margin-bottom:1rem;
					}
					.ant-input-affix-wrapper {
						width: 100% !important;
						margin-top:1rem;
						margin-bottom:0.75rem;
					}
				}
			}
		}
		.cloud-plan-wrapper {
			.cloud-content {
    			padding: 1rem !important;
			}
			.cloud-box-container {
				flex-direction: column;
				justify-content: center;
				.content-align {
					flex-direction: column;
					.cloud-icon {
						margin:0px
					}
					.sub-title {
						text-align:center;
					}
				}
			}
			.cloud-content {
				padding: 1rem;
			}
		}
		.my-mini .ant-select {
			width: 100%;
		}
		.payment-container {
			.qr-code-wrapper {
				margin-left: 0;
			}
			.steps-content-wrapper .payment-details-wrapper {
				flex-direction: column;
			}
			.data-content .ant-breadcrumb .breadcrumb-item-active {
				border-top: 3px solid #ffffff;
			}
			.enterprise-form-wrapper .enterprise-form {
				padding: 0.5rem;
			}
			.box-container.inc-padding {
				padding: 0;
			}
		}
		.ant-breadcrumb-link .breadcrumb-item {
			padding-top: 0;
		}
	}
	@media (max-width: 280px) {
		.content-panel {
			.wrapper-container {
				height: 40rem;
				.divider {
					padding: 1rem 2rem;
				}
				.card-container {
					padding:2rem 0rem 0rem 2rem;
				}
			}
		}
		.cloud-plan-wrapper {
			.cloud-content {
    			padding: 0rem !important;
			}
			.cloud-box-container {
				flex-direction: column;
				justify-content: center;
			}
			.cloud-content {
				padding: 1rem;
			}
		}
		.box-container .content-wrapper .popular-container {
			min-width: 15rem;
		}
		.payment-container {
			.enterprise-form-wrapper .enterprise-form {
				margin: 0;
			}
		}
	}
`;

export default Wrapper;

export const EnterPriseWrapper = styled.div`
    margin: 1rem 0 0.5rem 0.5rem;
    padding-top: 2rem;
`;

export const WarningWrapper = styled.div`
	padding: 1rem;
	.message {
    	margin-bottom: 2rem;
	}
	.ant-btn {
		width: 100%;
	}
`;
export const PlanModalWrapper = styled.div`
	.box-container {
		.content-wrapper {
			.content {
				margin: 0;
				border-color: #808083;
			}
			.popular-container:nth-child(2) {
				.content {
					border-left:  none;
					border-right: none;
				}
			}
			.popular-label {
				margin: 0rem;
				width: 100%;
			}
		}
	}
`;

export const FiatConfirmationWrapper = styled.div`
	.fiat-application-wrapper {
		padding: 2rem;
		background-color :#29292c;
		position: relative;
		width: 100%;
		z-index: 1;
		.submitted-info {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #008D00;
			color: #FFFFFF;
			width: 100px;
			text-align: center;
			border-radius: 13px;
			.anticon {
				margin-right: 5px;
			}
		}
		.title {
			font-size: 30px;
			font-weight: bold;
		}
		.main-info {
			margin: 1.5rem 0;
		}
		.btn-wrapper {
			width: 100%;
			margin-top: 1.5rem;
			display: flex;
			justify-content: space-between;
			.close-btn {
				width: 30%;
				border-color: #4C00FF;
			}
			.view-plan-btn {
				width: 70%;
				margin-left: 10px;
			}
			.w-30 {
				width: 30%;
			}
			.w-70 {
				width: 70%;
			}
		}
	}
	.fiat-application-wrapper::before {
		content: "";
		background-image: url(${FIAT_MASTER_PLAN_BACKGROUND});
		background-position: right;
		background-size: contain;
		background-repeat: no-repeat;
		background-color: #29292c;
		opacity: 0.4;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		z-index: -1;
	}
	@media (max-width: 425px) {
		.fiat-application-wrapper .title {
			font-size: 24px;
		}
		.btn-wrapper {
			flex-direction: column;
			button {
				margin-top:1rem;
				width: 100% !important;
			}
		}
	}
`

export const PluginBillingWrapper = styled.div`
	.pl-2 {
			padding: 2rem;
		}
	.plugin-wrapper {
		.d-flex {
			display: flex;
		}
		.title-content {
			font-size: 18px;
			margin-bottom: 10px;
		}
		.content-wrapper {
			border: 1px solid #75809B;
			padding: 1rem 2rem 0rem 2rem;
			.kyc-plugin-icon {
				width: 8%;
				height: 5%;
			}
			.content-details-wrapper{
				margin-left: 1rem;
				width: 50%;
				margin-bottom: 3rem;
				.plugin-app-label, .plugin-description{
					font-size: 14px;
				}
				.plugin-name {
					font-size: 16px;
					font-weight: bold;
				}
				.footer-content {
					color: #B6B6B6;
					margin-top: 10px;
					.custom-div {
						margin: 0px 5px 0px 5px;
					}
					.verify-badge-icon {
						width: 5%;
						margin-right: 5px;
					}
					.one-time-activation-icon {
						width: 5%;
						margin: 0px 5px 0px 5px;
					}
				}
			}
		}
		.custom-divider {
			border: 2px dotted #75809B;
			width: 10px;
			height: 8rem;
			border-bottom: none;
			border-right: none;
			border-top: none;
			opacity: 1;
		}
		.plugin-btn-wrapper {
			margin-top: 3rem;
		}
		.plugin-btn-wrapper .ant-btn .ant-btn-primary .ant-btn-block {
				height: 2.5rem !important;
		}
		.display-cost {
			align-items: center;
			margin-left: 1rem;
			font-size: 18px;
		}
	}

	@media (max-width: 550px) {
		.plugin-wrapper {
			.content-wrapper {
				flex-direction: column;
    			align-items: center;
				.kyc-plugin-icon {
					width: 20%;
    				height: 15%;
					margin: 1rem 0rem 1rem 0rem;
				}
				.content-details-wrapper {
					text-align: center;
					margin-bottom: 1rem;
					width: 70%;
					.footer-content {
						display: flex;
						flex-direction: column;
						align-items: center;
						.verify-badge-icon {
							width: 10%;
						}
						.one-time-activation-icon {
							width: 10%;
						}
					}
				}
			}
			.custom-divider {
				border-bottom: 2px dotted #75809B;
				width: 100%;
				height: unset;
		 	}
			.display-cost {
				margin: 2rem 0rem 2rem 0rem;
				text-align: center;
		    }
		}
	}
`